export default () => ({
  play() {
    const player = this.$refs.hoverVideo
    if (!player) return
    player.play()
  },
  reset() {
    const player = this.$refs.hoverVideo
    if (!player) return
    player.pause()
    player.currentTime = 0
  },
})
